import { render, staticRenderFns } from "./fccGrupos.vue?vue&type=template&id=053a6824"
import script from "./fccGrupos.vue?vue&type=script&lang=js"
export * from "./fccGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports